// RelationshipWorkspaceHeader. Mirrors data-component=
// "relationship-workspace-header" from the approved HTML: eyebrow,
// heading and the primary "+ Add relationship" button.
//
// TODO(runtime): "Add relationship" opens the shared editor dialog
// which, on save, calls services/relationships.create once the HTTP
// endpoint lands.
import type { ReactNode } from 'react';

export interface RelationshipWorkspaceHeaderProps {
  customerFirstName: string;
  onAddRelationship: () => void;
}

export function RelationshipWorkspaceHeader({
  customerFirstName,
  onAddRelationship,
}: RelationshipWorkspaceHeaderProps): ReactNode {
  return (
    <div
      className="horse-toolbar"
      data-component="relationship-workspace-header"
    >
      <div>
        <span className="eyebrow">
          {customerFirstName.toUpperCase()}&rsquo;S CONNECTIONS
        </span>
        <h2>Good care is a team effort.</h2>
      </div>
      <button
        type="button"
        className="blue-action"
        onClick={onAddRelationship}
      >
        + Add relationship
      </button>
    </div>
  );
}
